import { render } from "./MessageChart.vue?vue&type=template&id=65cc298e&scoped=true"
import script from "./MessageChart.vue?vue&type=script&lang=js"
export * from "./MessageChart.vue?vue&type=script&lang=js"

import "./widget.css?vue&type=style&index=0&id=65cc298e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cc298e"]])

export default __exports__